export default "__VITE_ASSET__BWBXiAkq__"